/**
 * Helpers da escolha de conteúdos (catálogo vem da API /credenciamento-conteudos-agenda).
 */

export const MAX_CONTEUDOS_REGULARES = 1;

/** Limite de participantes por conteúdo (editorial ou patrocinado). */
export const MAX_VAGAS_POR_CONTEUDO = 45;

export function encontrarConteudoPorId(id, catalogo = []) {
  return catalogo.find((c) => c.id === id) || null;
}

export function idsConteudosRegulares(selectedIds, catalogo = []) {
  return selectedIds.filter((id) => Boolean(encontrarConteudoPorId(id, catalogo)));
}
